import { useActions } from '.';
import { ScannerYoko } from '../devices/scanners/impl/ScannerYoko';
import { Logger } from '../devices/logger/interface/Logger';
export const useScanner = () => {
  const { setScannerAction } = useActions();
  const setScanner = async (logger: Logger) => {
    try {
      const scanner = new ScannerYoko(logger);
      setScannerAction(scanner);
    } catch (exception) {
      logger.error(exception);
    }
  };
  return [setScanner] as const;
};
